// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

import config from './config'

axios.defaults.headers.common = {
  "Authorization": localStorage.getItem('authorization')
};

Vue.prototype.axios = axios;
Vue.prototype.config = config;

Vue.config.productionTip = false

import Panel from './components/Panel'
import List from './components/List'

Vue.component('panel', Panel)
Vue.component('list', List)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js